import React, { useEffect, useState } from "react"
import { View } from "react-native"
import MicrophoneLevelBars from "@common/components/microphone/MicrophoneLevelBars"
import { useMicrophoneLevel } from "../../../engine/precall/useMicrophoneLevel"
import { theme } from "@common/theme/theme"
import { useMicSignal } from "../../../engine/precall/useMicSignal"

/**
 * Le niveau du micro, mesuré uniquement pendant l'étape micro.
 *
 * La mesure se rafraîchit dix fois par seconde. Laissée dans le panneau, elle
 * en re-rendait tout le contenu — aperçu caméra compris — pendant la totalité
 * du parcours, et gardait une capture audio ouverte jusqu'à l'étape caméra :
 * exactement la situation d'accès concurrent qu'on cherche à éviter. Isolée
 * ici, elle ne re-rend qu'elle-même, et le panneau n'apprend qu'une chose, une
 * seule fois : on t'a entendu.
 */
export const MicrophoneLevel = ({ deviceId, onHeard }) => {
    // Les barres écoutent le micro choisi, pas celui du système : sinon le
    // sélecteur ne change rien de visible et ne prouve rien.
    const micLevel = useMicrophoneLevel({ microphone: true }, deviceId)
    const hasSignal = useMicSignal(micLevel)

    useEffect(() => {
        if (hasSignal) onHeard()
    }, [hasSignal, onHeard])

    return <MicrophoneLevelBars micLevel={micLevel} />
}

/**
 * Le niveau de sortie pendant le test du son.
 *
 * Elle dit une seule chose, et il faut l'entendre au sens strict : **une
 * lecture a été lancée.** Elle ne prouve pas qu'un son est sorti — c'est
 * `playbackStarted` qui s'en charge, en observant la piste pendant sa lecture.
 */
export const OutputLevel = ({ playing }) => {
    const [tick, setTick] = useState(0)

    useEffect(() => {
        if (!playing) return undefined
        const timer = setInterval(() => setTick((n) => n + 1), 90)
        return () => clearInterval(timer)
    }, [playing])

    return (
        <View style={{ flexDirection: "row", alignItems: "flex-end", height: 30 }}>
            {[0, 1, 2, 3, 4, 5].map((index) => {
                const lit = playing && (tick + index) % 6 < 4
                return (
                    <View
                        key={index}
                        style={{
                            width: 6,
                            marginRight: 4,
                            borderRadius: 3,
                            height: lit ? 12 + ((index * 7) % 18) : 6,
                            backgroundColor: lit ? theme.colors.primary : theme.colors.lighter,
                        }}
                    />
                )
            })}
        </View>
    )
}
